import React, { useEffect, useState } from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { ProjectionScreenReport } from "service/report";

interface LiveEventsProps {
    eventsData: ProjectionScreenReport;
}

export default function LiveEvents({ eventsData }: LiveEventsProps) {
    const [count, setCount] = useState(0);
    const { liveCount, onlineQueCount } = eventsData;

    useEffect(() => {
        setCount(liveCount + onlineQueCount);
    }, [eventsData]);

    return (
        <div className={style.root}>
            <div className={style.subtitle}>直播活动（{count}）</div>

            <div className={style.container}>
                <div className={classNames(style.card)}>
                    <div className={style.title}>直播次数</div>
                    <div className={style.count}>
                        {eventsData?.liveCount}
                        <span className={style.unit}>个</span>
                    </div>
                    <div className={style.detail}>
                        直播观看率
                        <span className={style.blue}>
                            {" "}
                            {eventsData?.livePercent}
                        </span>
                    </div>
                </div>

                <div className={classNames(style.card, style["question"])}>
                    <div className={style.title}>发布问卷</div>
                    <div className={style.count}>
                        {eventsData?.onlineQueCount}
                        <span className={style.unit}>个</span>
                    </div>
                    <div className={style.detail}>
                        问卷参与率
                        <span className={style.yellow}>
                            {" "}
                            {eventsData?.onlineQuePercent}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
